const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  async updateRoom({getters,dispatch}, newData) {
    const existingData = {
      startTime: getters.getSpaceStartTime,
      endTime: getters.getSpaceEndTime,
      hostEmail: getters.getSpaceHostEmail,
      topic: getters.getSpaceName,
      joinLink: getters.getSpaceJoinLink,
      conferenceType: getters.getSpaceConferenceType,
      baseAngle: getters.getSpaceBaseAngle,
      color: getters.getSpaceColour,
      imageUrl: getters.getSpaceImage
    }

    const mergedData = {
      ...existingData,
      ...newData
    }

    let res = await dispatch('api/nav/updateRoom', [getters.getSpacePageId, mergedData])
    if(res?.success) dispatch('analytics/editRoom', {id: getters.getSpacePageId, ...mergedData, isPortal: getters.getSpaceIfPortal})
    return res
  },
  async handleChangeSpaceTitle({getters,dispatch}, newName) {
    newName = newName.trim()
    if(!newName) return

    let res = await dispatch('updateRoom', {
      name: newName
    })

    let data = res.success
    if(!data) return dispatch('popups/nav/errorUpdatingRoomTitle')

    dispatch('popups/nav/successUpdatingRoomTitle')
    // the below messes things up when you're on the area overview + isn't necessary
    if(getters['routing/routeName'] === 'area') return

    dispatch('updateLocation', [data.location])
  },
  async handleCustomizeRoom({getters,dispatch}, [name, color, imageUrl, textColor, hideName, joinLink, baseAngle]) {
    let res = await dispatch('updateRoom', {
      topic: name,
      color,
      imageUrl,
      textColor,
      hideName,
      joinLink,
      baseAngle
    })

    let data = res.success
    if(!data) return dispatch('popups/nav/errorCustomisingRoom')

    dispatch('popups/nav/successCustomisingRoom', name)
    // the below messes things up when you're on the area overview + isn't necessary
    if(getters['routing/routeName'] === 'area') {
      //update room info so when clicking customise again the data is up to date
      if(getters.getSpacePageId === data.id) await dispatch('updateCurrentSpacePage', data.location)
      return
    }

    dispatch('updateLocation', [data.location])

    return res
  },

  // room guest ----------------------------------------------------------------
  async handleToggleRoomLobby({dispatch}, [roomId, value, showSuccessPopup = true]) {
    let res = await dispatch('api/nav/toggleRoomLobby', [roomId, value])

    let data = res.success
    if(!data) return dispatch('popups/show/error/custom', `turning ${value ? 'on' : 'off'} the Lobby`, {root: true})
    dispatch('analytics/toggleRoomLobby', [roomId, value])

    if (showSuccessPopup) {
      dispatch('popups/show/success',{
        message: `Successfully turned ${value ? 'on' : 'off'} the Lobby. <br><br> ${value ? 'Guests will need to be accepted  <br> or use a password before they can join the room.' : 'Guests can now enter this room without any approval.'}`
      })
    }

    return res
  },
  async handleRemoveRoomPassword({dispatch}, roomId) {
    let res = await dispatch('api/nav/removeRoomPassword', roomId)

    let data = res.success
    if(!data) {
      dispatch('popups/show/error/custom', 'removing the password for this Room', {root: true})
      return
    }
    dispatch('analytics/toggleRoomPassword', [roomId, 'off'])

    dispatch('popups/show/success',{
      message: 'Successfully removed Room password. <br><br> Guests can no longer join this room with a previous password.'
    })

    return res
  },
  async handleAddRoomPassword({dispatch}, [roomId, value]) {
    let res = await dispatch('api/nav/addRoomPassword', [roomId, value])

    let data = res.success
    if(!data) {
      dispatch('popups/show/error/custom', 'adding the Room password', {root: true})
      return
    }
    dispatch('analytics/toggleRoomPassword', [roomId, 'on'])

    dispatch('popups/show/success',{
      message: 'Successfully added Room password.'
    })

    return res
  },
  async handleAcceptRoomLobbyGuest({dispatch}, [roomId, userId]) {
    let res = await dispatch('api/nav/acceptLobbyUser', [roomId, userId])

    let data = res.success
    if(!data) {
      return dispatch('popups/guest/errorUpdateRoomLobbyGuestAccess', 'accepting')
    }
    dispatch('analytics/respondToGuestInRoomLobby', [roomId, userId, 'accept'])

    dispatch('popups/guest/successUpdateRoomLobbyGuestAccess', 'accepted')

    return res
  },
  async handleRejectRoomLobbyGuest({dispatch}, [roomId, userId]) {
    let res = await dispatch('api/nav/rejectLobbyUser', [roomId, userId])

    let data = res.success
    if(!data) {
      return dispatch('popups/guest/errorUpdateRoomLobbyGuestAccess', 'declining')
    }
    dispatch('analytics/respondToGuestInRoomLobby', [roomId, userId, 'reject'])

    dispatch('popups/guest/successUpdateRoomLobbyGuestAccess', 'declined')

    return res
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
